/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * instead, edit one of the `.graphql` files in this project and run
 * `pnpm nx run graphql:codegen `
 * for this file to be re-created
 */
import * as Types from '@main/graphql/types.generated';

import type { TypedDocumentNode } from '@graphql-typed-document-node/core';
import * as ClientTypes from '@main/graphql/client-scalars';
import { api } from '@main/graphql/shared-api';
export type GetOrganizationsByUserIdQueryVariables = Types.Exact<{
  userId: Types.Scalars['uuid']['input'];
}>;

export type GetOrganizationsByUserIdQuery = {
  __typename?: 'query_root';
  organization_users: Array<{
    __typename?: 'organization_users';
    disabled: boolean;
    organization: {
      __typename?: 'organizations';
      id: string;
      name: string;
      parent_organization_id?: string | null;
    };
    role: {
      __typename?: 'roles';
      id: string;
      name: string;
      system_role?: Types.System_Roles_Enum | null;
    };
  }>;
};

export const GetOrganizationsByUserIdDocument = `
    query GetOrganizationsByUserId($userId: uuid!) {
  organization_users(where: {user_id: {_eq: $userId}}) {
    disabled
    organization {
      id
      name
      parent_organization_id
    }
    role {
      id
      name
      system_role
    }
  }
}
    ` as string &
  TypedDocumentNode<GetOrganizationsByUserIdQuery, GetOrganizationsByUserIdQueryVariables>;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    GetOrganizationsByUserId: build.query<
      GetOrganizationsByUserIdQuery,
      GetOrganizationsByUserIdQueryVariables
    >({
      query: (variables) => ({ document: GetOrganizationsByUserIdDocument, variables }),
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetOrganizationsByUserIdQuery, useLazyGetOrganizationsByUserIdQuery } =
  injectedRtkApi;
